<button mat-menu-item (click)="selectClinicalNotes()">
  <mat-icon>note_add</mat-icon>
  <span>{{ label() }}</span>
</button>
